<app-page-title title="Crianças"></app-page-title>

<div class="search-container">
  <input
    class="search-input"
    placeholder="Buscar..."
    [(ngModel)]="searchValue"
    (input)="search($event.target.value)"
    autocomplete="off"
  />
  <div class="search-img">
    <img src="../../../assets/icons/search-white.svg" sizes="1" />
  </div>
</div>
<br />

<app-no-data *ngIf="!children?.length" title="Sem dados" subtitle=" Nenhuma estudo cadastrado"></app-no-data>

<section id="children-list" *ngIf="children?.length">
  <div>
    <div *ngIf="children.length == 0" class="empty-result">Nenhum usuário encontrado :-(</div>
    <cdk-virtual-scroll-viewport itemSize="20" class="example-viewport">
      <div *cdkVirtualFor="let child of children" class="example-item">
        <div class="photo">
          <img *ngIf="child.avatar" [src]="getAvatar()" [matTooltip]="child.name" matTooltipClass="tooltip" />

          <img
            *ngIf="!child.avatar"
            [matTooltip]="child.name"
            matTooltipClass="tooltip"
            [src]="'../../../assets/images/child-' + child.gender + '.png'"
          />
        </div>
        <div class="details">
          <div class="name">{{ child.name }}</div>
          <div class="action-buttons">
            <button>
              <img
                src="../../../assets/icons/visibility_black_24dp.svg"
                matTooltip="Vizualizar"
                [routerLink]="['/crianca/vizualizar/' + child.id]"
              />
            </button>
            <button class="btn-edit">
              <img src="../../../assets/icons/edit.svg" matTooltip="Editar" [routerLink]="['/crianca/' + child.id]" />
            </button>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</section>

<div class="example-button-container">
  <button mat-fab color="primary" aria-label="Example icon button with a delete icon" [routerLink]="['/crianca/add']">
    <img src="../../../assets/icons/add_white_24dp.svg" />
  </button>
</div>
